<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center p-3 globalborder-btm-header mb-3">
        <span class="col-auto">
          <h2 class="mb-0">AR Details</h2>
        </span>

        <div class="d-flex gap-3 align-items-center">
          <div
            class="prospects-panel d-flex justify-content-between ms-2 me-auto">
            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="All"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="this.selectedRadioButton === 'All' ? true : false"
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">ALL</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="120"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="this.selectedRadioButton === '120' ? true : false"
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">120+</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="90"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="this.selectedRadioButton === '90' ? true : false"
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">90+</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="60"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="this.selectedRadioButton === '60' ? true : false"
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">60+</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="30"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="this.selectedRadioButton === '30' ? true : false"
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">30+</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="0"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="this.selectedRadioButton === '0' ? true : false"
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">0< 30</span>
            </label>

            <label class="ms-2 nav-link p-0 d-flex align-items-center">
              <input
                pInputText
                id="Current"
                type="radio"
                class="me-2"
                name="radio"
                [checked]="
                  this.selectedRadioButton === 'Current' ? true : false
                "
                (click)="getMainFiltersOnChange($event)" />

              <span class="link">Current</span>
            </label>

            <div
              title="Create notes for selected invoices"
              class="ms-3 p-0 dropdown d-flex align-items-center gap-3">
              <label class="ms-2 p-0 d-flex align-items-center" for="All">
                Client
              </label>
              <input
                pInputText
                id="All"
                type="text"
                class="p-column-filter p-inputtext p-component"
                (input)="
                  dt.filter($any($event.target).value, 'clientD365', 'contains')
                " />
            </div>

            <div
              (click)="openSideBarForOrderNotes()"
              title="Create notes for selected invoices"
              class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
              <i class="icon-Notes icon"></i>
            </div>
          </div>

          <div class="col-auto">
            <p-button
              label="Export Excel"
              variant="outlined"
              icon="pi pi-cloud-upload"
              severity="secondary"
              (click)="exportExcelForFilterData()"
              class="fullwdth secondary-btn" />
          </div>

          <span
            *ngIf="fromDashboard"
            class="cross-border"
            (click)="onCloseModal()"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </span>
      <div class="col-lg-12 adduser-container-hgt">
        <p-table
          #dt
          stripedRows
          [size]="'small'"
          scrollHeight="650px"
          [showCurrentPageReport]="true"
          [paginator]="false"
          responsiveLayout="scroll"
          [(selection)]="customerAgingDetailReportListsSelection"
          responsiveLayout="scroll"
          [value]="filterCustomerAgingDetailReportLists"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="customerAgingDetailReportLists.length >= 50"
          selectionMode="multiple"
          editMode="row"
          (onFilter)="onFilter($event)">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th></th>
              <th>Invoice</th>
              <th>Sales Order</th>
              <th>Client Name</th>
              <th>Client PO #</th>
              <th>Job Name</th>
              <th>Due Date</th>
              <th>Orig Inv Amt</th>
              <th>Cur</th>
              <th>Terms</th>
              <th>Outstanding $</th>
              <th>Days Past Due</th>
              <th>Note AR</th>
              <th [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
                AR Notes
              </th>
            </tr>
            <tr>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="invoice"
                    id="invoice"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'invoice',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrder"
                    id="salesOrder"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrder',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="clientD365"
                    id="clientD365"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'clientD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customerPONumber"
                    id="customerPONumber"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customerPONumber',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="projectName"
                    id="projectName"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'projectName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-arAgingDetailsReportList
            let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pEditableRow]="arAgingDetailsReportList"
              [pSelectableRow]="arAgingDetailsReportList"
              [pSelectableRowIndex]="rowIndex">
              <td class="col-center">
                <p-tableCheckbox
                  class=""
                  [value]="arAgingDetailsReportList"
                  [pSelectableRow]="arAgingDetailsReportList"></p-tableCheckbox>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    getProjectInvoiceReport(
                      arAgingDetailsReportList?.invoice,
                      arAgingDetailsReportList?.invDate
                    )
                  ">
                  {{ arAgingDetailsReportList?.invoice }}
                </a>
              </td>

              <td>
                <a
                  class="link"
                  (click)="
                    redirectToSaleorder(arAgingDetailsReportList?.salesOrder)
                  ">
                  {{ arAgingDetailsReportList?.salesOrder }}
                </a>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClientSummary(
                      arAgingDetailsReportList.customerAccount
                    )
                  ">
                  {{ arAgingDetailsReportList?.clientD365 }}</a
                >
              </td>
              <td>{{ arAgingDetailsReportList?.customerPONumber }}</td>
              <td>{{ arAgingDetailsReportList?.projectName }}</td>
              <td>
                {{ arAgingDetailsReportList?.dueDate | date: "MM-dd-yyyy" }}
              </td>
              <td>{{ arAgingDetailsReportList?.invoiceAmount }}</td>
              <td>{{ arAgingDetailsReportList?.currency }}</td>
              <td>{{ arAgingDetailsReportList?.paymTermId }}</td>
              <td class="text-right">
                {{
                  arAgingDetailsReportList?.openAmountUSD
                    | currency: "USD" : "symbol" : "0.2-2"
                }}
              </td>
              <td>{{ arAgingDetailsReportList?.daysPastDate }}</td>
              <td
                class="text-center number"
                (click)="
                  showInputFieldForLineNote(
                    arAgingDetailsReportList?.recIdD365,
                    arAgingDetailsReportList?.note
                  )
                ">
                <a class="link"><i class="icon-Notes icon"></i></a>
              </td>
              <td
                [ngClass]="{
                  'trimmeddescription trimmedby50char':
                    descriptionCharacterCond,
                }">
                {{ descriptionCharacterCount(arAgingDetailsReportList.note) }}
                {{ arAgingDetailsReportList?.note }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="footer">
            <tr>
              <td style="text-align: right" colspan="11">
                {{ totalOutstanding | currency: "USD" : "symbol" : "1.2-2" }}
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<!-- <div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>AR Details</h1>
    <div class="prospects-panel d-flex justify-content-between ms-2 me-auto">
      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="All"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === 'All' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">ALL</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="120"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === '120' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">120+</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="90"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === '90' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">90+</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="60"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === '60' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">60+</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="30"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === '30' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">30+</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="0"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === '0' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">0< 30</span>
      </label>

      <label class="ms-2 nav-link p-0 d-flex align-items-center">
        <input pInputText 
          id="Current"
          type="radio"
          class="me-2"
          name="radio"
          [checked]="this.selectedRadioButton === 'Current' ? true : false"
          (click)="getMainFiltersOnChange($event)" />

        <span class="link">Current</span>
      </label>

      <div
        title="Create notes for selected invoices"
        class="ms-3 p-0 dropdown d-flex align-items-center">
        <label class="ms-2 p-0 d-flex align-items-center" for="All">
          <span
            style="
              color: #000000;
              text-align: left;
              padding: 0.5rem;
              font-weight: 600;
              font-size: 0.875rem;
            "
            >Client</span
          >
        </label>
        <input pInputText 
          id="All"
          type="text"
          class="p-column-filter p-inputtext p-component"
          (input)="
            dt.filter($any($event.target).value, 'clientD365', 'contains')
          " />
      </div>

      <div
        (click)="openSideBarForOrderNotes()"
        title="Create notes for selected invoices"
        class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Notes icon"></i>
      </div>
    </div>

    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcelForFilterData()">Export excel</a>
      </div>
    </div>
  </header>

  <div class="p-wrapper-custom">
    <p-table
      #dt
      [(selection)]="customerAgingDetailReportListsSelection"
      responsiveLayout="scroll"
      [value]="filterCustomerAgingDetailReportLists"
      styleClass="p-datatable-customers"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 1000]"
      [autoLayout]="true"
      [resizableColumns]="true"
      [paginator]="customerAgingDetailReportLists.length >= 20"
      selectionMode="multiple"
      editMode="row"
      (onFilter)="onFilter($event)">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th >Invoice</th>
          <th >Sales Order</th>
          <th >Client Name</th>
          <th >Client PO #</th>
          <th >Job Name</th>
          <th >Due Date</th>
          <th >Orig Inv Amt</th>
          <th >Cur</th>
          <th >Terms</th>
          <th >Outstanding $</th>
          <th >Days Past Due</th>
          <th >Note AR</th>
          <th
            
            [ngClass]="{ trimmedby50char: descriptionCharacterCond }">
            AR Notes
          </th>
        </tr>
        <tr>
          <th></th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="invoice"
                id="invoice"
               
                (input)="
                  dt.filter($any($event.target).value, 'invoice', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="salesOrder"
                id="salesOrder"
               
                (input)="
                  dt.filter($any($event.target).value, 'salesOrder', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="clientD365"
                id="clientD365"
               
                (input)="
                  dt.filter($any($event.target).value, 'clientD365', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="customerPONumber"
                id="customerPONumber"
               
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'customerPONumber',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input pInputText 
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="projectName"
                id="projectName"
               
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'projectName',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-arAgingDetailsReportList
        let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pEditableRow]="arAgingDetailsReportList"
          [pSelectableRow]="arAgingDetailsReportList"
          [pSelectableRowIndex]="rowIndex">
          <td class="col-center">
            <p-tableCheckbox
              class=""
              [value]="arAgingDetailsReportList"
              [pSelectableRow]="arAgingDetailsReportList"></p-tableCheckbox>
          </td>
          <td>
            <a
              class="link"
              (click)="
                getProjectInvoiceReport(
                  arAgingDetailsReportList?.invoice,
                  arAgingDetailsReportList?.invDate
                )
              ">
              {{ arAgingDetailsReportList?.invoice }}
            </a>
          </td>

          <td>
            <a
              class="link"
              (click)="
                redirectToSaleorder(arAgingDetailsReportList?.salesOrder)
              ">
              {{ arAgingDetailsReportList?.salesOrder }}
            </a>
          </td>
          <td>
            <a
              class="link"
              (click)="
                redirectToClientSummary(
                  arAgingDetailsReportList.customerAccount
                )
              ">
              {{ arAgingDetailsReportList?.clientD365 }}</a
            >
          </td>
          <td>{{ arAgingDetailsReportList?.customerPONumber }}</td>
          <td>{{ arAgingDetailsReportList?.projectName }}</td>
          <td>{{ arAgingDetailsReportList?.dueDate | date: "MM-dd-yyyy" }}</td>
          <td>{{ arAgingDetailsReportList?.invoiceAmount }}</td>
          <td>{{ arAgingDetailsReportList?.currency }}</td>
          <td>{{ arAgingDetailsReportList?.paymTermId }}</td>
          <td class="text-right">
            {{
              arAgingDetailsReportList?.openAmountUSD
                | currency: "USD" : "symbol" : "0.2-2"
            }}
          </td>
          <td>{{ arAgingDetailsReportList?.daysPastDate }}</td>
          <td
            class="text-center number"
            (click)="
              showInputFieldForLineNote(
                arAgingDetailsReportList?.recIdD365,
                arAgingDetailsReportList?.note
              )
            ">
            <a class="link"><i class="icon-Notes icon"></i></a>
          </td>
          <td
            [ngClass]="{
              'trimmeddescription trimmedby50char': descriptionCharacterCond,
            }">
            {{ descriptionCharacterCount(arAgingDetailsReportList.note) }}
            {{ arAgingDetailsReportList?.note }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="30">No Data Found.</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        <tr>
          <td style="text-align: right" colspan="11">
            {{ totalOutstanding | currency: "USD" : "symbol" : "1.2-2" }}
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div> -->

<jni-ar-aging-details-note
  #ordernotessidebar
  [(display)]="displaySidebarForNotes"
  [notes]="notesForSidebar"
  [recIdList]="selectedRecIdList"
  (closeSidebar)="closeSideBarForOrderNotes()"
  (saveNotesEvent)="saveNotes($event)"></jni-ar-aging-details-note>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeClientModal()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="customerId"
      (closeEvent)="closeClientModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>
